export default __webpack_public_path__ + "static/media/PDF.fe9d433f.svg";